import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { Column, Row } from "../columns";
import "./InfoBar.scss";
import { InfoBarContext } from "./";
import { cleanJoin } from "../../utils/stringUtil";

function InfoBar({ title, contentComponent, user, isOpen = false }) {
  const ContentComponent = contentComponent;
  const infoBar = useContext(InfoBarContext);

  return (
    <div className={cleanJoin("info-bar", "is-radiusless p-4", !isOpen ? "is-hidden" : "")}>
      <Row>
        <Column className="is-size-4">
          <div className="is-pulled-left has-text-weight-bold has-text-grey-darker">
            {title || ""}
          </div>
          <div className="is-pulled-right has-text-right is-clickable">
            <FontAwesomeIcon icon={faTimesCircle} onClick={() => infoBar.toggle(null, null)} />
          </div>
        </Column>
      </Row>
      {contentComponent && <ContentComponent user={user} />}
    </div>
  );
}

export default InfoBar;
